export const elementNodeShouldHaveChildren = (node: any) => {
  if (node?.type && node?.children?.length === 0) {
    return null;
  }

  return node;
};
